import React from 'react';
import { motion } from 'framer-motion';
interface FeedTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}
export function FeedTabs({
  activeTab,
  setActiveTab
}: FeedTabsProps) {
  const tabs = ['Following', 'For You', 'Trending'];
  return <div className="absolute top-12 left-0 right-0 flex justify-center z-30 pointer-events-none" data-id="element-85">
      <div className="flex gap-6 pointer-events-auto" data-id="element-86">
        {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className="relative pb-2" data-id="element-87">
            <span className={`text-lg font-bold transition-colors drop-shadow-md ${activeTab === tab ? 'text-white' : 'text-white/60'}`} data-id="element-88">
              {tab}
            </span>
            {activeTab === tab && <motion.div layoutId="feedTabIndicator" className="absolute bottom-0 left-1/2 -translate-x-1/2 w-6 h-1 bg-primary rounded-full" transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30
        }} data-id="element-89" />}
          </button>)}
      </div>
    </div>;
}